 //due to time and budget more elegant solution doesn't exist....

 $(document).ready(function(){

 	//ios flexbox issue fix.

 	$(window).on("resize",onResize);
 	onResize();
 	
 });




 function onResize(event){
 	setTimeout(function(){
 		afterResize();
 	},150);
 }

 function afterResize(){
 	 $(".leaf--left").each(function(){

 		var leftLeaf = $(this);
 		var rightLeaf = leftLeaf.closest(".leaves").find(".leaf--right");
 		leftLeaf.css("min-height","");
 		rightLeaf.css("min-height","");

 		
 		if(leftLeaf.offset().top == rightLeaf.offset().top){
 			var h = Math.max(leftLeaf.parent().height(),rightLeaf.parent().height());
 			leftLeaf.css("min-height",h);
 			rightLeaf.css("min-height",h);
 		}
 	});

	$(".navigation__list.nav_sub li a").css("min-height","");

 	var ulItems = $(".navigation__list.nav_sub");

 	ulItems.each(function(){
 		var ulItem = $(this);
 		var sorter= {};	
 		var liItems = ulItem.find("li");
 		liItems.each(function(){
 			var liItem = $(this);
 			var bounds = liItem[0].getBoundingClientRect();
 			//console.log(bounds);
 			if(sorter[bounds.top]==undefined){
 				sorter[bounds.top] = [];
 			}
 			sorter[bounds.top].push(liItem);
 		});
 		for(var index in sorter){
 			var list = sorter[index];
 			var maxH = 0;
 			for(var i = 0 ; i < list.length;i++){
 				maxH = Math.max(maxH,list[i].outerHeight());
 			}
 			for(var i = 0 ; i < list.length;i++){
 				//maxH = Math.max(maxH,list[i].height());
 				var diff = maxH - list[i].height();
 				list[i].find('> a').css("min-height",maxH);
 			}
 			
 		}

 	});
 	
 }

 


// WEBPACK FOOTER //
// ./BBZP/Frontend/js/modules/hacky-fixes.js